module.exports = __webpack_public_path__ + "static/media/pdf_active_black.df428006.svg";